import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierSR-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import SRPolicyChangesPage from './pages/SRPolicyChanges/SRPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierSRPolicyChangesPage: { component: 'PremierSRPolicyChangesPage' }
    },
    {
        PremierSRPolicyChangesPage: SRPolicyChangesPage
    }
);

export { default as PremierSRPolicyChangeWizard } from './PremierSRPolicyChangeWizard';
